export default {
  data() {
    return {
      statusEnum: {
        0: '未支付',
        1: '已支付',
        2: '待收货',
        3: '已完成',
        4: '售后中',
        5: '退款失败',
        6: '已退款',
      },
      qb_statusEnum: {
        3: '充值成功',
        6: '充值失败',
        2: '充值中'
      },
      channlList: [{
        label: '海威',
        value: 'HW'
      }],
      statusList: [{
          label: '待收货',
          value: [1, 2]
        }, {
          label: '已完成',
          value: [3]
        }, {
          label: '已退款',
          value: [6]
        },
        {
          label: '售后中',
          value: [4]
        }
      ],

      appereanceList: [{
        label: '卡券',
        value: 1
      }, {
        label: '直充',
        value: 2
      }],

    }
  },
  watch: {
    'date' (n) {
      let [orderDateStart, orderDateEnd] = n
      console.log(orderDateStart)
      this.searchObj.orderDateStart = orderDateStart ? `${orderDateStart} 00:00:00` : ''
      this.searchObj.orderDateEnd = orderDateEnd ? `${orderDateEnd} 23:59:59` : ''
    }
  },
  methods: {
    handleClick({ name, $parent: { $el } }) {
      let { target } = $el.dataset
      let orderStatus = name ? name.split(',').map(e => Number(e)) : ''
      this.searchObj[target] = orderStatus
      this.$nextTick(() => {
        this.search()
      })
    },
    jump(params, name) {
      let parent = name == 'order' ? '订单管理' : '售后管理'
        // window.location.href = `./detail.html?orderCode=${orderCode}`
      let target = ['嘀加权益卡管理平台', '运营平台', '权益', parent, '*详情']
      if (window.$config.axios.environment) {
        let arr = name == 'order' ? 　['订单管理', '*权益订单详情'] : ['售后管理', '售后详情']
        target = ['权益卡管理平台', '运营平台', 'SCRM权益平台', ...arr]
      }
      console.log(target, { orderCode: params.orderCode })
      this.$root.to(target, { orderCode: params.orderCode })
    }
  },
}